const rows = [{ id: 1, type: 'negociacao', nome: 'Texto de Proposta' }];

const tableHeader = ['Proposta', 'Editar', 'Excluir'];

const Tablecadastro = [
  { id: 'nome', title: 'Texto para Proposta', type: 'text', placeholder: 'Informe o texto da proposta ...' },
];

const title = 'Cadastro de proposta';

export const cadastro = {
  title: title,
  cadastro: Tablecadastro,
};

export const table = {
  header: tableHeader,
  type: 'negociacao',
  rows: rows,
};
